import { useQuery } from 'react-query';
import { WebComponentUIContext } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { getWebComponentToken } from '../justifi.api';

export const useCreateWebComponentToken = ({
  disputeId,
  locationId,
  webComponentUiContext,
}: {
  disputeId: string;
  locationId: string;
  webComponentUiContext: WebComponentUIContext;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: [locationId, 'justifi', 'web-component-token', disputeId],
    queryFn: async () =>
      getWebComponentToken({ webComponentUiContext, locationId, disputeId }),
    enabled: !!locationId,
  });

  return { authToken: data?.accessToken, loading: isLoading };
};
